<template>
  <div class="full-reduction-pop">
    <van-popup v-model="show" position="bottom" round safe-area-inset-bottom :close-on-popstate="true" :style="{ height: '70%' }">
      <PopupHeaderTool title="满减优惠" @close="close"/>
      <div class="content">
        <div v-for="(item,index) in fullReductionData" :key="`full${index}`" class="full-reduction-card text-overflow" @click="openFullCourse(item)">
          <TagComponent text="满减优惠"/>
          <div class="card-item text-overflow">{{fullReductionTypeToText(item.fullDiscountConditionList)}}</div>
          <img src="../../../assets/img/public/left_arrow.png" alt="" class="left-arrow">
        </div>
      </div>
    </van-popup>
    <FullReduction ref="fullReduction" :activityData="activityData" :allActivity="allActivity" :defaultSelectCourse="defaultSelectCourse"/>
  </div>
</template>

<script>
// eslint-disable-next-line import/extensions
import TagComponent from '@/components/commonComponents/TagComponent';
// eslint-disable-next-line import/extensions
import PopupHeaderTool from '@/components/commonComponents/PopupHeaderTool';
// eslint-disable-next-line import/extensions
import FullReduction from '@/components/courseDetail/fullReduction/FullReduction';

export default {
  components: { TagComponent, PopupHeaderTool, FullReduction },
  props: {
    showActivity: {
      type: Boolean,
      default: false,
    },
    allActivity: {
      type: Object,
      default: () => ({}),
    },
    defaultSelectCourse: {
      type: Array,
      default: () => ([]),
    },
  },
  data() {
    return {
      show: false,
      fullReductionData: {},
      activityData: {},
    };
  },
  mounted() {
    this.fullReductionData = this.allActivity.productDetailFullPromotionRespList;
  },
  methods: {
    fullReductionTypeToText(val) {
      let text = '';
      val.forEach((item, index) => {
        if (item.fullDiscountType === 1) {
          if (index === 0) {
            text = `满${item.fullAmount}减${item.discountAmount}`;
          } else {
            text = `${text}，满${item.fullAmount}减${item.discountAmount}`;
          }
        }
        if (item.fullDiscountType === 2) {
          text = `每满${item.fullAmount}减${item.discountAmount}`;
        }
        if (item.fullDiscountType === 3) {
          text = `满${item.fullAmount}打${item.discountRate}折`;
        }
      });
      return text;
    },
    close() {
      this.show = false;
    },
    openFullCourse(val) {
      this.activityData = val;
      console.log(val);
      this.$refs.fullReduction.show = true;
    },
  },
};
</script>
<style scoped lang="scss">
.full-reduction-pop{
  .content{
    height: calc(100% - 100px);
    padding: 20px 36px 0;
    overflow: scroll;

    .left-arrow{
      width: 14px;
      margin-left: auto;
    }

    .full-reduction-card{
      display: flex;
      align-items: center;
      width: 100%;
      height: 100px;
      margin-bottom: 18px;
      padding: 0 33px;
      border-radius: 14px;
      box-shadow: 0 0 9px 0 rgba(0,0,0,0.1);

      .tag-component{
        margin-right: 18px;
      }

      .card-item{
        padding-right: 20px;
        color: #333;
        font-weight: 400;
        font-size: 25px;
        line-height: 36px;
      }
    }
  }
}
</style>
